import { IWHLog } from '~/view/screens/WorkingHoursLogScreen/screens/WorkingHoursLog/store/WorkingHoursLogStore';
import './style.scss';
import { localeStore } from '~/mobx/localesStore';
import moment from 'moment/moment';

interface ChangesTableProps {
  log: IWHLog;
}

const ChangesTable: React.FC<ChangesTableProps> = ({ log }) => {
  const dataArray = Object.keys(log.changes).map((object) => ({
    object,
    object_name: log.profile,
    old: log.changes[object]?.before,
    new: log.changes[object]?.after,
    branch_action: log.action,
  }));

  const showHiddenValue = (value: any, object: string): any => {
    if (object === 'wh_log_details_timeslot_opentime_changed_event' || object === 'wh_log_details_timeslot_closetime_changed_event') {
      return getBusinessDateFormat(value);
    }

    return String(value ?? '-');
  };

  const showNameValue = (value: any): any => {
    return String(value ?? '-');
  };

  const getBusinessDateFormat = (time: string | null) => {
    if (time === null) {
      return '-';
    }

    return moment(time, 'HH:mm:ss').format('h:mm:ss A');
  };

  const showObject = (value: any): any => {
    if (log.model_type === 'branch') {
      return String(log.action);
    }

    return localeStore.t(value) ?? '-';
  };

  return (
    <div className="changes">
      <div className="changes-table">
        <div className="changes-table-header">
          <div className="changes-table-row">
            <div className="changes-table-cell size-object">{localeStore.t('name')}</div>
            <div className="changes-table-cell size-object">{localeStore.t('wh_log_action_col')}</div>
            <div className="changes-table-cell size-old">{localeStore.t('old')}</div>
            <div className="changes-table-cell size-new">{localeStore.t('new')}</div>
          </div>
        </div>
        <div className="changes-table-body">
          {dataArray.map((item, index) => (
            <div key={index} className="changes-table-row changes-table-row-content">
              <div className="changes-table-cell table-cell-data size-object">{showNameValue(item.object_name)}</div>
              <div className="changes-table-cell table-cell-data size-object">{showObject(item.object)}</div>
              <div className="changes-table-cell table-cell-data size-old">{showHiddenValue(item.old, item.object)}</div>
              <div className="changes-table-cell table-cell-data size-new">{showHiddenValue(item.new, item.object)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChangesTable;
